import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid__cell o-grid__cell--11 o-grid__cell--4-480"
}
const _hoisted_2 = ["value", "id", "data-cy"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "c-form-control-radio__label-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.gte(_ctx.props.zahlweiseBeitrag, _ctx.props.zahlweiseMindestbeitrag))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.zahlungsweise) = $event)),
          value: _ctx.props.zahlweiseFeldWert,
          id: _ctx.feldId,
          name: "tariffPaymentFrequency",
          class: "c-form-control-radio__input",
          type: "radio",
          "data-parsley-multiple": "tariffPaymentFrequency",
          "data-cy": _ctx.feldId
        }, null, 8, _hoisted_2), [
          [
            _vModelRadio,
            _ctx.piniaStore.state.tarifinformationen.zahlungsweise,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("label", {
          for: _ctx.feldId,
          class: "c-form-control-radio__label"
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", {
            "aria-hidden": "true",
            class: "c-form-control-radio__icon"
          }, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.props.zahlweiseText + " " + _ctx.formatCurrency(_ctx.props.zahlweiseBeitrag)), 1)
        ], 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}